// @flow
import componentLocator from './component_locator';
import useServiceWorker from './configuration.js.erb';

type Component = {
    id: number,
    hash: string,
    name: string,
    deferred: boolean,
    fixed: boolean,
    children: Array<number>,
    options: ({} | string),
    extra_params: {},
}

let latestPageRequest = null;
class Router {
    async loadPage(page: string, ids:?Array<Number>=null) {
        if (!(await this._waitUntilReady())) return Promise.resolve(); // Queue multiple requests.

        return new Promise(resolve => {
            $.getJSON(`components/${page}`, {}, async (result, _, xhr: any) => {
                $('meta[name="csrf-token"]').attr('content', xhr.getResponseHeader('x-authenticity-token'));
                if (useServiceWorker && ('serviceWorker' in navigator)) {
                    $('body').toggleClass('online', navigator.onLine);
                    $('body').toggleClass('offline', !navigator.onLine);
                }
                await new ComponentReloader(result).reload();
                await this.updateDocumentMetadata(page);
                resolve();
            }).fail(() => {
                window.location.href = `/${page}`; // Load the page normally.
            });
        });
    }

    async updateDocumentMetadata(page: string) {
        $(document).attr("title", page.toLowerCase().split('_')
            .map((str) => str.charAt(0).toUpperCase() + str.substring(1)).join(' ')); 
        
        let oldBodyClass = $('body').attr('class').split(' ').slice(0, -1).join(' ');
        $('body').attr('class', `${oldBodyClass} ${page.toLowerCase().replace(' ', '_')}`);

        window.history.pushState({st_async: true}, null, encodeURIComponent(page));

        if (componentLocator.f.selectPage) {
            await componentLocator.f.selectPage(page);
        }
    }

    async _waitUntilReady() {
        let requestId = Math.random();
        latestPageRequest = requestId;
        let fallbackTimer = new Promise(resolve => setTimeout(resolve, 1000))

        // Wait for components to load, or 1 second (whichever comes first).
        await Promise.race([componentLocator.waitUntilLoaded(), fallbackTimer]);
        return latestPageRequest = latestPageRequest == requestId;
    }
}

class ComponentReloader {
    oldComponents: Map<number, Component>;
    result: Array<Component>;
    componentsToReload: Set<number>;

    constructor(new_components: Array<Component>) {
        this.result = new_components;
        this.oldComponents = this.groupById(window.components);
        this.componentsToReload = new Set();
    }

    async reload() {
        await this.recursiveDelete(0);
        this.rerender();
    }

    rerender() {
        window.__componentAdapter.fragments = window.__componentAdapter.fragments || {}; // TODO: Move to the end.
        window.components = this.result;
        window.__componentAdapter.componentsWaiting = 0;
        window.__componentAdapter.render(0, false);
    }

    async recursiveDelete(id: number) {
        let component: any = this.oldComponents.get(id);
        component.children.forEach(child => this.recursiveDelete(child));
        await componentLocator.deleteComponent(component.id);
        // window.__componentAdapter.fragments[component.hash] = [
        //     component.children,  $(`#wrapper_${component.id}`).html()
        // ];
        $(`#wrapper_${component.id}`).html('');
        // // close but wrong
        // if (id !== 0 && window.__componentAdapter.fragments[component.hash]) {
        //     $(`#wrapper_${component.id}`).find('div[id^="wrapper_"]').each(function() { this.id = `_${this.id}`});
        //     $(`#wrapper_${component.id}`).attr('id', `_wrapper_${component.id}`);
        // } else {
        //     $(`#wrapper_${component.id}`).html('');
        // }
    }

    groupById(items: Array<Component>): Map<number, Component> {
        return items.reduce((map, e) => map.set(e.id, e), new Map());
    }
}

export default new Router();